/*
 * Die Anwendertexte von Kopieren und Nachfolge (Spec „Kopieren und Nachfolge“, Aufgabe 27; Hausregel „Texte in
 * Properties“): Schlüssel englisch, Werte deutsch. „ersetzt ‹Nr›“ ist dasselbe Wort wie an den Kacheln der
 * Kundenübersicht (`ROW_TEXT.replaces`, W33) — einmal geschrieben.
 */
import { ROW_TEXT } from "../../views/customerOverview/texts.js";

/** Die Höchstlänge des Anlasses einer neuen Version — Spiegel von `VERSION_NOTE_MAXLAENGE` der Domäne (477 b); web importiert
 *  domain nie. Das Feld der Rückfrage trägt sie als `maxlength` (Review 28 K1). */
export const VERSION_NOTE_MAX_LENGTH = 500;

export const SUCCESSION_TEXT = {
  // --- Kopierrückfrage (CopyOfferDialog) ---
  copyTitle: "Angebot kopieren?",
  copyText: "Kopieren legt ein neues Angebot mit neuer Nummer an; Positionen, Texte, Zahlplan und Anlagen werden "
    + "übernommen, Dateien nicht. Für eine weitere Fassung dieses Angebots nimm ‚Neue Version‘.",
  copyReplaces: (number: string): string => `Das neue Angebot ersetzt ${number}`,
  copyAction: "Kopieren",
  copied: (number: string): string => `Das Angebot wurde als ${number} kopiert.`,
  copyFailed: "Das Angebot konnte nicht kopiert werden.",

  // --- Nachfolge-Chips und Kopf ---
  replaces: ROW_TEXT.replaces,
  replacedBy: (number: string): string => `ersetzt durch ${number}`,
  /** Das Sofort-Popup an einem Nachfolge-Chip: „‹Titel› · ‹Datum› · ‹Status›“. */
  seriesPopup: (title: string, date: string, status: string): string => `${title} · ${date} · ${status}`,
  /** Die Gruppe der Chips für die Vorlesestimme. */
  chipsLabel: "Nachfolge",
  openFailed: "Das Angebot konnte nicht geöffnet werden.",
  copiedFrom: (number: string, version: number): string => `kopiert aus ${number} v${version}`,

  // --- Sendesperre ---
  replacedHint: (number: string): string => `Durch ${number} ersetzt — wird nicht mehr versandt.`,

  // --- Feld „Ersetzt“ ---
  field: "Ersetzt",
  fieldNone: "— keines —",
  fieldSearch: "Angebot suchen …",

  // --- Bereich: Suchtreffer in einer älteren Version (W15) ---
  matchedVersion: (n: number): string => `Treffer in v${n}`,

  // --- Versionen: Anlass der neuen Version (477 b) — Frage, Feld und Spalte der Versionstabelle ---
  newVersionTitle: "Neue Version anlegen?",
  newVersionText: "Es entsteht eine neue Version dieses Angebots mit derselben Nummer. Die aktuelle "
    + "Fassung wird dabei zur alten Version und lässt sich danach nicht mehr ändern. Fortfahren?",
  /** Der Knopf an den Aktionen und die Bestätigung der Rückfrage. */
  newVersion: "Neue Version",
  restoreTitle: "Fassung wiederherstellen?",
  restoreText: "Es entsteht eine neue Version mit den Inhalten DIESER älteren Fassung. Die aktuelle "
    + "Fassung wird dabei zur alten Version und lässt sich danach nicht mehr ändern. Fortfahren?",
  restoreConfirm: "Wiederherstellen",
  versionNoteLabel: "Anlass",

  // --- Versionen: ältere Version ansehen (Dirk 484) ---
  viewAction: "Ansehen",
  viewActionLabel: (n: number): string => `Version ${n} ansehen`,
  viewTitle: (n: number, date: string): string => `Version ${n} vom ${date}`,
  viewLoading: "Die Version wird gerendert …",
  viewFailed: "Die Version konnte nicht angezeigt werden.",
  /** Über dem Blatt einer nie gesendeten Version: Sie wird HEUTE gerendert, mit heutigen Bausteinen und Layout. */
  neverSent: "nie gesendet — Textbausteine und Layout im heutigen Stand",
} as const;
